module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stepThree"
  }, [(_vm.spinShow) ? _c('Spin', {
    attrs: {
      "size": "large",
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('headers'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('steps', {
    attrs: {
      "step-num": 2
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "stepThree-form"
  }, [_c('div', {
    staticClass: "stepTow-tip"
  }, [_c('Icon', {
    attrs: {
      "type": "md-alert"
    }
  }), _vm._v(" 检测到您在我校已绑定手机号 " + _vm._s(_vm.phoneNum) + "，请使用短信验证码激活。如预置手机号有误，请“钉钉”联系信息中心阮月光老师。")], 1), _vm._v(" "), _c('Form', {
    ref: "formValidate",
    attrs: {
      "model": _vm.formValidate,
      "rules": _vm.ruleValidate,
      "label-width": 0
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "password": "",
      "placeholder": "请输入新密码"
    },
    model: {
      value: (_vm.formValidate.password),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "password", $$v)
      },
      expression: "formValidate.password"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "passwords"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "password": "",
      "placeholder": "请确认新密码"
    },
    model: {
      value: (_vm.formValidate.passwords),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "passwords", $$v)
      },
      expression: "formValidate.passwords"
    }
  })], 1), _vm._v(" "), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary",
      "long": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formValidate')
      }
    }
  }, [_vm._v("下一步")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77387656!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mobile/stepThree.vue
// module id = 202
// module chunks = 0